import { useLocalSearchParams, router } from 'expo-router';
import { ConversationScreen } from '@/components/domain/messages/ConversationScreen';
import { useIsLargeScreen } from '@/hooks/useIsLargeScreen';
import { MessagesScreen } from '@/components/domain/messages/MessagesScreen';

export default function MessageConversationPage() {
  const { id } = useLocalSearchParams();
  const isLargeScreen = useIsLargeScreen();
  const messageId = parseInt(id as string, 10);

  if (isNaN(messageId)) {
    router.navigate('/messages/inbox'); // if the message id is not a number, navigate to the inbox
  }

  if (isLargeScreen) {
    return <MessagesScreen initialMessageType="inbox" messageId={messageId} />;
  }

  return <ConversationScreen messageId={messageId} />;
} 